import gql from 'graphql-tag'

// NOTE: be careful when replacing `gql` with `questionnaireGql` since this can break `recordAudienceChangedForIRSNotification` work. Double check if the `recordAudienceChangedForIRSNotification` is still working after the replacement.
export const CREATE_AUDIENCE_MEMBER_V2 = gql(`
  mutation createAudienceMemberV2(
    $input: CreateAudienceMemberV2Input!
    $skipIRSNotificationRecording: Boolean = false
  ) {
    recordAudienceChangedForIRSNotification @client(always: true)
    @skip(if: $skipIRSNotificationRecording) 
    createAudienceMemberV2(input: $input) {
      ...DraftAudienceMember
    }
  }
`)
